<template>
	<Row>
		<Container>
			<div
				class="flex flex-col md:flex-row justify-center md:justify-between md:items-end py-[64px] lg:py-[72px] text-center md:text-left"
			>
				<div class="md:pr-8">
					<h2
						class="gradient-title-white text-[50px] lg:text-[54px] font-semibold text-center md:text-left"
					>
						Join Our Mentorship Program&nbsp;—&nbsp;
					</h2>
					<h2
						class="gradient-title-white text-[50px] lg:text-[54px] font-semibold text-center md:text-left"
					>
						The Daily Income Trader
					</h2>
				</div>

				<CtaButton
					class="mt-6 md:mt-0"
					height="66"
					:to="'https://cfn.dailyincometraders.com/hp-dit-cart'"
					type="secondary"
					:centered="false"
					:blank="true"
					dataCtaType="mentoship-program-price"
				>
					{{ "View Pricing" }}
				</CtaButton>
			</div>

			<div class="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
				<div class="lg:col-span-3 flex justify-center items-center pb-6 lg:pb-0">
					<div class="big-image">
						<NuxtLink
							class="youtube-item"
							to="https://www.youtube.com/watch?v=Ka638b5p3C0&"
							target="_blank"
						>
							<img
								src="/images/mentorship-video-img.png"
								class="big-thumbnail"
								width="717"
								height="504"
								alt="yt-image-1"
							/>
						</NuxtLink>
					</div>
				</div>
				<div class="lg:col-span-2">
					<!-- <h2 class="text-[24px] md:text-[28px] font-bold text-gray-800 mb-4">
                        Here's what you can expect inside our daily live sessions:
                    </h2> -->
					<div class="space-y-6">
						<div
							v-for="(item, index) in items"
							:key="index"
							class="flex items-start gap-2"
						>
							<img
								src="/images/checkmark.svg"
								alt="Checkmark"
								class="w-6 h-6 flex-shrink-0"
							/>
							<div>
								<div class="text-lg font-bold text-slate-100">{{ item.title }}</div>
								<p class="text-base text-slate-300">{{ item.description }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Container>
	</Row>
</template>

<script setup>
import { ref } from "vue";

// New design text
// const items = ref([
// 	{
// 		title: "Adapting to Market Dynamics",
// 		description:
// 			"In our live sessions, we'll show you our 3-step trading system that always finds good trades no matter how the market is doing."
// 	},
// 	{
// 		title: "From Tech Giants to Small Caps",
// 		description:
// 			"Big companies like Apple and Microsoft boosted the market, but now experts predict a move to smaller stocks."
// 	},
// 	{
// 		title: "Real-Time Demonstrations",
// 		description:
// 			"Expect real-time, actionable trade ideas inside your daily live training sessions."
// 	},
// 	{
// 		title: "Interactive Q&A Session",
// 		description:
// 			"Our team will ensure that you get all your burning questions about this system answered."
// 	}
// ]);

const items = ref([
	{
		title: "Adapting to Market Dynamics",
		description:
			"Wall Street is 50/50 on 2024 – so let’s prepare for both. Inside our live sessions, we will reveal how our 3-step trading system has consistently identified high-potential trades across all market climates."
	},
	{
		title: "From Tech Giants to Small Caps",
		description:
			"While mega-cap stocks like Apple and Microsoft have driven market rallies, analysts are forecasting a shift into the broader market… and smaller stocks –discover how our system was custom-built to pick up this exact activity!"
	},
	{
		title: "Real-Time Demonstrations",
		description:
			"These aren't generic tips; they're curated insights made by our state-of-the-art technology. Expect real-time, actionable trade ideas in your daily live training sessions."
	},
	{
		title: "Interactive Q&A Session",
		description:
			"Our team will ensure that you get all your burning questions about this system answered."
	}
]);
</script>

<style lang="scss" scoped>
.big-image {
	overflow: hidden;
	.youtube-item {
		text-decoration: none;
		display: block;
		position: relative;

		@include breakpoint(lg) {
			.big-image-content {
				position: absolute;
				bottom: 0;
				left: 0;
				z-index: 2;
				width: 100%;
				text-align: start;
				max-height: 504px;
				.content-title {
					font-size: 20px;
				}

				.clock-time {
					font-family: DM Sans;
					font-size: 14px;
					font-style: normal;
					font-weight: 400;
					line-height: 22px;
				}
			}
		}

		&::before {
			content: "";
			position: absolute;
			top: 35%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 96px;
			height: 96px;
			background: url("/images/play-button.svg") no-repeat center center;
			background-size: contain;
			z-index: 2;
			transition: transform 0.3s ease;

			@include breakpoint(lg) {
				top: 50%;
				width: 72px;
				height: 72px;
			}
		}

		&:hover::before {
			transform: translate(-50%, -50%) scale(1.5);
		}
	}
}

.big-thumbnail {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	border-radius: 16px;
}
</style>
